/**
 * What a **Versand operator** did to a Lieferung (TM-9636 / #1630, ADR-0035).
 *
 * ⚠ **A log and not a state column.** What stands here a human did; what stands
 * on the Lieferung is the consequence of it. Both in one column would mean no
 * longer being able to tell an action and its outcome apart — and that is
 * exactly the question a practice asks when its Lieferung is suddenly *accepted*
 * without a Rückmeldung having arrived.
 *
 * ⚠ **`varchar` in the table, not `enum`.** TM-9637 puts hold, diversion and
 * resend beside them; an `enum` column would need an `ALTER` each time over a
 * table nothing is ever deleted from.
 */
export var VersandOperatorActKind;
(function (VersandOperatorActKind) {
    /**
     * An unmatched Rückmeldung was matched to a Versandversuch by hand and then
     * applied — as a Ruf 1 (#1624) or as a Verarbeitungsmeldung (#1625).
     */
    VersandOperatorActKind["RUECKMELDUNG_ASSIGNED"] = "RUECKMELDUNG_ASSIGNED";
    /**
     * An unmatched Rückmeldung belongs to no Lieferung and was taken out of the
     * queue.
     *
     * ⚠ **The mail stays lying there.** *Discarded* means: it is no longer work,
     * not: it is gone. The purge command is TM-9637.
     */
    VersandOperatorActKind["RUECKMELDUNG_DISCARDED"] = "RUECKMELDUNG_DISCARDED";
    /**
     * A Prüf-Lieferung (`UNB.0035 = 0`, a test office's file) was sent by an
     * operator (#1958) — through the dispatch step the queue takes, which skips it.
     *
     * ⚠ **The office gives no Versand-Freigabe for it.** #1582 decision 4: a
     * Prüf-Lieferung is triggered by an operator only, because its
     * Datenaustauschreferenz is spent the moment it goes out. This row is who
     * decided that moment, and why.
     */
    VersandOperatorActKind["TEST_FILE_SENT"] = "TEST_FILE_SENT";
    /**
     * The unencrypted Nutzdatendatei of a waiting Prüf-Lieferung was downloaded,
     * to be checked in IQVIA's TA-Validator before it is sent (#1959).
     *
     * ⚠ **Test files only.** A Prüf-Lieferung comes from a test office and carries
     * synthetic data by definition; every other Lieferung's Nutzdatendatei is
     * payload and has no download (#1594). The act stands on the Lieferung like
     * every other, so the office sees each time its file left Therame's hands.
     */
    VersandOperatorActKind["TEST_FILE_DOWNLOADED"] = "TEST_FILE_DOWNLOADED";
})(VersandOperatorActKind || (VersandOperatorActKind = {}));
//# sourceMappingURL=versand-operator-act-kind.enum.js.map